export function getFriendlyName(value) {
    const friendlyNames = {
        "from.funnel.card.field.change": "Quando um campo é atualizado",
        "from.funnel.card.inOut.stage":"Quando um card entra ou sai de um estágio",
        "to.funnel.card.change.qualify": "Alterar qualificação do card",
        "from.funnel.card.in.stage": "Quando um card entra em um estágio",
        "to.chat.create": "Criar chat",
        "card_criado": "Quando um Card é Criado",
        "card_saiu_estagio": "Quando um Card Sai de um Estágio",
        "card_entrou_estagio": "Quando um Card Entra em um Estágio",
        "inatividade_card_funil": "Inatividade no Card no Funil",
        "chat_aceito": "Qunado um é Chat Aceito",
        "chat_palavra_chave": "Qunado há uma Palavra-Chave no Chat",
        "chat_direcionado": "Chat Direcionado",
        "mover_card_funil": "Mover Card para Funil",
        "atualizar_campo": "Atualizar Campo",
        "criar_nota_chat": "Criar Nota no Chat",
        "qualificar_lead": "Qualificar Lead",
        "criar_card": "Criar Card",
        "criar_chat": "Criar Chat",
        "adicionar_etiqueta": "Adicionar Etiqueta",
        "enviar_msg_chat": "Enviar Mensagem no Chat",
        "distribuir_responsaveis": "Distribuir Responsáveis",
        "to.httpRequest": "Criar requisição HTTP",
        "to.chat.sendMessage": "Enviar mensagem no chat",
        "to.funnel.changeUser": "Alterar usuário do card no funil",
        "to.chat.addNote": "Adicionar nota no chat",
        "from.funnel.card.out.stage": "Quando sai de um estágio",
        "from.chat.create": "Quando um chat é criado",
        "to.chat.addTag": "Adicionar tag no chat",
        "to.moveCardStage": "Mover card de estágio",
        "to.funnel.action": "Executar ação no funil",
        "from.jobs.birthdate": "Quando é aniversário",
        "from.chat.assign": "Quando chat é transferido",
        "from.chat.accept": "Quando chat é aceito",
        "from.funnel.card.inativity": "Quando um card fica sem atividade",
         "from.chat.inactivity": "Quando um chat fica sem atividade",
         "to.chat.transfer": "Transferir chat",
          "to.chat.finish": "Finalizar chat",
          "from.chat.contains": "Quando chat contém",
          "to.funnel.cardCreate": "Criar card no funil",
          "from.funnel.card.create": "Quando um card é criado no funil",
          "to.chat.removeTag": "Remover tag do chat",
          "from.chat.tag.inOut": "Quando tag é adicionada ou removida",
          "from.chat.firstMessage": "Quando é a primeira mensagem",
          "from.chat.feedback": "Quando é nota de avaliação",
          "from.chat.finish": "Quando chat é finalizado",
          "from.chats.resume": "Quando é o resumo da conversa",
          "to.funnel.cardTransferUser": "Transferir o card para um usuário",
          "from.chamado.create": "Quando um chamado é criado",
          "from.chamado.status.change": "Quando o status do chamado muda",
          "from.chamado.finish": "Quando um chamado é concluído",
          "from.chamado.comment": "Quando um comentário é adicionado no chamado",
          "from.formulario.response.submit": "Quando uma resposta de formulário é enviada",
          "from.tarefa.create": "Quando uma tarefa é criada",
          "from.tarefa.status.change": "Quando o status da tarefa muda",
          "from.tarefa.finish": "Quando uma tarefa é concluída",
      };
    return friendlyNames[value] || value;
  }
  
